import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import './Header.css';
import AnnouncementBar from './AnnouncementBar';

const Header = () => {
  const { t, i18n } = useTranslation();
  const [navOpen, setNavOpen] = useState(false);
  const [languageOpen, setLanguageOpen] = useState(false);

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
    setLanguageOpen(false);
  };

  const openNav = () => {
    setLanguageOpen(false);
    setNavOpen((prev) => !prev);
  };

  const openLanguage = () => {
    setNavOpen(false);
    setLanguageOpen((prev) => !prev);
  };

  const languages = [
    { code: 'en', name: 'English' },
    { code: 'he', name: 'עברית' },
    { code: 'ar', name: 'العربية' },
    { code: 'ru', name: 'Русский' },
  ];

  const currentLang = languages.find((l) => l.code === i18n.language)?.name || 'EN';

  return (
    <>
      <AnnouncementBar />
      <header className="header" role="banner">
        <div className="container">
          <div className="header-content">
          <a href="/" className="logo" aria-label={`${t('appName')} - Home`}>
            <span className="logo-icon" aria-hidden="true"><img src="/images/logo.png" alt={t('appName')} /></span>
            <span className="logo-text"><span className="titleGlow">Glow</span><span className="titleApp">App</span></span>
          </a>
          
          <nav className={`nav ${navOpen ? 'nav-open' : ''}`} role="navigation" aria-label="Main navigation">
            <a href="/#features" onClick={() => setNavOpen(false)}>{t('features')}</a>
            <a href="/#benefits" onClick={() => setNavOpen(false)}>{t('benefits')}</a>
            <a href="/#pricing" onClick={() => setNavOpen(false)}>{t('pricing')}</a>
            <a href="/#faq" onClick={() => setNavOpen(false)}>{t('faq')}</a>
            <a href="/#contact" onClick={() => setNavOpen(false)}>{t('contact')}</a>
          </nav>

          <div className="header-actions">
            <div className="language-selector language-selector--desktop">
              <button 
                type="button"
                className="language-btn"
                onClick={openLanguage}
                aria-label="Select language"
                aria-expanded={languageOpen}
              >
                {currentLang}
                <span className="dropdown-arrow" aria-hidden="true">▼</span>
              </button>
              {languageOpen && (
                <div className="language-menu">
                  {languages.map((lang) => (
                    <button
                      key={lang.code}
                      type="button"
                      className={`language-option ${i18n.language === lang.code ? 'active' : ''}`}
                      onClick={() => changeLanguage(lang.code)}
                    >
                      {lang.name}
                    </button>
                  ))}
                </div>
              )}
            </div>
            <a href="https://app.glowapp.me" target="_blank" rel="noreferrer" className="btn btn-primary btn-start">
              {t('startNow')}
            </a>
          </div>

          <button 
            type="button"
            className="mobile-menu-toggle"
            onClick={openNav}
            aria-label="Toggle menu"
            aria-expanded={navOpen}
          >
            <span></span>
            <span></span>
            <span></span>
          </button>
        </div>
      </div>
      </header>
    </>
  );
};

export default Header;